import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock/lib/bodyScrollLock.es6';
import { $Elements, BrowserEvents, Classes, Elements } from './constants';

//=================================
//	!---------- MENU ----------
//=================================

;(function($) {

	// ---------- Toggle ----------

	$Elements.document.on(BrowserEvents.page.enter, () => {

		$('.menu-toggle, a[href="#menu-wrapper"]').on('click touchstart', e => {
			e.preventDefault();

			if($Elements.body.hasClass(Classes.menuOpen)) {
				$Elements.body.removeClass(Classes.menuOpen);
				enableBodyScroll(Elements.MenuWrapper);
			}
			else {
				$Elements.body.addClass(Classes.menuOpen);
				disableBodyScroll(Elements.MenuWrapper);
			}
		});
	});

	// ---------- Curseur ----------
	// Le curseur vit hors du conteneur Barba : il est attaché une seule fois,
	// et n'est visible qu'avec un pointeur fin (voir _header.scss).

	const cursor = document.querySelector('.menu-cursor');

	if(cursor && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {

		let frame = null;

		document.addEventListener('mousemove', e => {

			if(frame !== null) {
				return;
			}

			frame = requestAnimationFrame(() => {
				cursor.style.transform = 'translate3d(' + e.clientX + 'px, ' + e.clientY + 'px, 0)';
				frame = null;
			});
		});
	}

}(jQuery));
